import React from "react";
import { Radio, RadioChangeEvent } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleRadioProps extends React.ComponentProps<typeof Radio> {
  useEditorTheme?: boolean;
}

// Export the event type
export type { RadioChangeEvent as TrebbleRadioChangeEvent };

const TrebbleRadioComponent = ({ useEditorTheme, ...restProps }: TrebbleRadioProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Radio {...restProps} />
    </TrebbleConfigProvider>
  );
};

// Re-exporting sub-components like Group and Button
TrebbleRadioComponent.Group = Radio.Group;
TrebbleRadioComponent.Button = Radio.Button;

// Type assertion
const TrebbleRadio = TrebbleRadioComponent as typeof TrebbleRadioComponent & {
    Group: typeof Radio.Group;
    Button: typeof Radio.Button;
};

export default TrebbleRadio; 